export default {"src":"/_next/static/media/wallet_money_64.776b925c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};